(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aircube-evidence"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aircube-featured-reviews')) {
    customElements.define('aircube-featured-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-review-track]');
        this.cards = [...this.querySelectorAll('[data-review-card]')];
        this.controls = this.querySelector('[data-review-controls]');
        if (!this.track || !this.cards.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = this.index || 0;
        this.targetIndex = null;
        this.dragging = false;
        this.onResize = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.measure();
            if (this.dragging) this.resizePending = true;
            else this.goTo(this.index, false);
          });
        };
        this.addEventListener('click', event => {
          if (event.target.closest('[data-review-prev]')) this.step(-1);
          if (event.target.closest('[data-review-next]')) this.step(1);
          const opener = event.target.closest('[data-review-open]');
          if (!opener || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const dialog = opener.closest('[data-review-card]').querySelector('[data-review-dialog]');
          if (typeof dialog?.showModal !== 'function') return;
          try { dialog.showModal(); } catch { return; }
          event.preventDefault();
          this.openDialog = dialog;
          this.opener = opener;
          this.lockScroll();
          const image = dialog.querySelector('[data-review-image]');
          if (image && !image.hasAttribute('src')) image.src = image.dataset.src;
        }, { signal });
        this.cards.forEach(card => {
          const dialog = card.querySelector('[data-review-dialog]');
          const opener = card.querySelector('[data-review-open]');
          if (typeof dialog?.showModal !== 'function') return;
          opener.setAttribute('aria-haspopup', 'dialog');
          opener.setAttribute('aria-controls', dialog.id);
          dialog.querySelector('[data-review-close]').addEventListener('click', () => dialog.close(), { signal });
          dialog.querySelector('[data-review-source]').addEventListener('click', () => { this.opener = null; dialog.close(); this.releaseScroll(); }, { signal });
          dialog.addEventListener('close', () => this.finishDialog(dialog), { signal });
          dialog.addEventListener('pointerdown', event => { this.backdropStart = event.target === dialog && this.outside(dialog, event); }, { signal });
          dialog.addEventListener('click', event => {
            if (event.target === dialog && this.backdropStart && this.outside(dialog, event)) dialog.close();
            this.backdropStart = false;
          }, { signal });
        });
        this.track.addEventListener('scroll', () => { clearTimeout(this.scrollTimer); this.scrollTimer = setTimeout(() => this.settle(), 140); }, { passive: true, signal });
        this.track.addEventListener('scrollend', () => this.settle(), { signal });
        this.track.addEventListener('pointerdown', () => { this.dragging = true; this.targetIndex = null; }, { passive: true, signal });
        const endDrag = () => {
          if (!this.dragging) return;
          this.dragging = false;
          if (this.resizePending) { this.resizePending = false; this.onResize(); }
        };
        window.addEventListener('pointerup', endDrag, { passive: true, signal });
        window.addEventListener('pointercancel', endDrag, { passive: true, signal });
        this.track.addEventListener('focusin', event => {
          const card = event.target.closest('[data-review-card]');
          if (!card || this.openDialog) return;
          const rect = card.getBoundingClientRect(), view = this.track.getBoundingClientRect();
          if (rect.left < view.left - 1 || rect.right > view.right + 1) this.goTo(this.cards.indexOf(card), false);
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
          if (!card) return;
          this.measure();
          this.goTo(this.cards.indexOf(card), false);
          card.querySelector('[data-review-open]').focus({ preventScroll: true });
        }, { signal });
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.goTo(this.targetIndex ?? this.index, false); }, { signal });
        if (typeof ResizeObserver === 'function') { this.resizes = new ResizeObserver(this.onResize); this.resizes.observe(this.track); }
        else window.addEventListener('resize', this.onResize, { passive: true, signal });
        if (this.cards.every(card => typeof card.querySelector('[data-review-dialog]')?.showModal === 'function')) this.setAttribute('data-enhanced', '');
        this.setAttribute('data-controls-ready', '');
        this.measure();
        this.goTo(this.index, false);
      }
      measure() {
        this.measuredWidth = this.track.clientWidth;
        this.visible = Math.max(1, Number.parseInt(getComputedStyle(this).getPropertyValue('--ac-review-visible'), 10) || 1);
        this.maxIndex = Math.max(0, this.cards.length - this.visible);
        this.offsets = this.cards.map(card => card.offsetLeft - this.cards[0].offsetLeft);
        this.index = Math.min(this.index, this.maxIndex);
        this.controls.hidden = this.maxIndex === 0;
      }
      settle() {
        clearTimeout(this.scrollTimer);
        if (this.dragging || !this.offsets) return;
        if (this.track.clientWidth !== this.measuredWidth) { this.onResize(); return; }
        this.index = this.offsets.slice(0, this.maxIndex + 1).reduce((nearest, offset, index) => Math.abs(this.track.scrollLeft - offset) < Math.abs(this.track.scrollLeft - this.offsets[nearest]) ? index : nearest, 0);
        this.targetIndex = null;
      }
      goTo(index, smooth = true) {
        if (!this.offsets) return;
        this.index = Math.max(0, Math.min(index, this.maxIndex));
        this.targetIndex = this.index;
        this.track.scrollTo({ left: this.offsets[this.index] || 0, behavior: smooth && !this.motion.matches ? 'smooth' : 'instant' });
      }
      step(direction) {
        this.measure();
        const current = this.targetIndex ?? this.index, next = current + direction;
        this.goTo(next > this.maxIndex ? 0 : next < 0 ? this.maxIndex : next);
      }
      outside(dialog, event) {
        const rect = dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }
      lockScroll() {
        if (this.savedOverflow) return;
        this.savedOverflow = [document.documentElement, document.body].map(element => ({ element, x: element.style.getPropertyValue('overflow-x'), y: element.style.getPropertyValue('overflow-y'), xp: element.style.getPropertyPriority('overflow-x'), yp: element.style.getPropertyPriority('overflow-y') }));
        this.savedOverflow.forEach(({ element }) => element.style.setProperty('overflow', 'hidden'));
      }
      releaseScroll() {
        this.savedOverflow?.forEach(({ element, x, y, xp, yp }) => {
          if (x) element.style.setProperty('overflow-x', x, xp); else element.style.removeProperty('overflow-x');
          if (y) element.style.setProperty('overflow-y', y, yp); else element.style.removeProperty('overflow-y');
        });
        this.savedOverflow = null;
      }
      finishDialog(dialog) {
        if (this.openDialog !== dialog) return;
        const opener = this.opener;
        this.openDialog = null;
        this.opener = null;
        this.releaseScroll();
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        if (this.openDialog?.open) this.openDialog.close();
        this.releaseScroll();
        this.controller?.abort();
        this.controller = null;
        this.resizes?.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.scrollTimer);
        this.frame = null;
        this.openDialog = null;
        this.opener = null;
        this.removeAttribute('data-enhanced');
        this.removeAttribute('data-controls-ready');
        if (this.controls) this.controls.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aircube-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aircube-opening-reviews')) {
    customElements.define('aircube-opening-reviews', class extends HTMLElement {
      connectedCallback() {
        this.ratingObserver?.disconnect();
        const updateRating = () => {
          const score = this.querySelector('[data-ac-rating]');
          if (!score) return;
          const badge = this.querySelector('.jdgm-prev-badge');
          const rating = Number(badge?.getAttribute('data-average-rating'));
          const count = Number(badge?.getAttribute('data-number-of-reviews'));
          const valid = count > 0 && rating > 0 && rating <= 5;
          score.hidden = !valid;
          const label = valid ? rating.toFixed(1) + ' / 5' : '';
          if (score.textContent !== label) score.textContent = label;
        };
        this.ratingObserver = new MutationObserver(updateRating);
        this.ratingObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating', 'data-number-of-reviews'] });
        updateRating();
      }
      disconnectedCallback() { this.ratingObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aircube-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aircube-intro-demo')) {
    customElements.define('aircube-intro-demo', class extends HTMLElement {
      connectedCallback() {
        if (this.demoConnected) return;
        this.demoConnected = true;
        this.frame = null;
        this.layoutFrame = null;
        this.manualProgress = null;
        this.imageReady = false;
        this.previousScrollY = window.scrollY;
        this.didScroll = false;
        this.demoImage = this.querySelector('.ac-intro__demo-image');
        this.stage = this.querySelector('.ac-intro__demo-stage');
        this.runway = this.closest('[data-intro-runway]');
        this.hero = this.closest('.ac-intro__hero');
        this.navigation = document.querySelector('.ac-navigation');
        this.states = [...this.querySelectorAll('.ac-intro__demo-state')];
        this.cards = [...this.querySelectorAll('[data-demo-card]')];
        this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.buttons = [...this.querySelectorAll('[data-demo-color]')];
        this.updateCards = () => {
          const index = Number(this.dataset.color) || 0;
          const animated = this.dataset.cardsMode === 'animated';
          this.cards.forEach((card, position) => {
            const active = position === index;
            card.dataset.active = String(active);
            if (animated) card.setAttribute('aria-hidden', String(!active));
            else card.removeAttribute('aria-hidden');
          });
        };
        this.renderProgress = progress => {
          if (Math.abs(progress - this.lastProgress) < .0001) return;
          this.lastProgress = progress;
          const index = Math.round(progress * 2);
          this.dataset.color = String(index);
          this.updateCards();
          this.states.forEach((state, position) => {
            state.style.opacity = String(position === 0 ? 1 : Math.max(0, Math.min(1, progress * 2 - position + 1)));
          });
          this.buttons.forEach((button, position) => button.setAttribute('aria-pressed', String(position === index)));
        };
        this.stop = () => {
          if (this.frame !== null) window.cancelAnimationFrame(this.frame);
          this.frame = null;
        };
        this.measure = () => {
          const height = document.documentElement.clientHeight;
          const enabled = this.imageReady && this.dataset.animate === 'true' && this.dataset.pin === 'true' && !this.preference.matches && this.runway && this.hero;
          if (this.runway && this.hero) {
            const oldBounds = this.runway.getBoundingClientRect();
            const runwayTop = oldBounds.top + window.scrollY;
            const navHeight = this.navigation?.getBoundingClientRect().height || 0;
            const wasPinned = this.runway.dataset.pinReady === 'true';
            const anchor = oldBounds.bottom <= navHeight + 8
              ? this.runway.nextElementSibling
              : wasPinned && !enabled ? this.stage : null;
            const anchorTop = anchor?.getBoundingClientRect().top;
            this.dataset.cardsMode = this.imageReady && this.dataset.animate === 'true' && !this.preference.matches ? 'animated' : 'static';
            this.updateCards();
            if (enabled) {
              const heroHeight = this.hero.getBoundingClientRect().height;
              const distance = Math.max(760, Math.min(1600, height * 1.7));
              this.pinTop = Math.min(navHeight + 8, height - heroHeight - 12);
              this.runway.style.setProperty('--intro-pin-top', `${this.pinTop.toFixed(2)}px`);
              this.runway.style.setProperty('--intro-track-height', `${(heroHeight + distance).toFixed(2)}px`);
              this.runway.dataset.pinReady = 'true';
              this.start = runwayTop - this.pinTop;
              this.end = this.start + distance;
            } else {
              delete this.runway.dataset.pinReady;
              delete this.runway.dataset.pinProgress;
              this.runway.style.removeProperty('--intro-pin-top');
              this.runway.style.removeProperty('--intro-track-height');
            }
            if (anchor && Number.isFinite(anchorTop)) {
              const shift = anchor.getBoundingClientRect().top - anchorTop;
              if (Math.abs(shift) > .5) window.scrollBy({ top: shift, left: 0, behavior: 'instant' });
            }
          }
          this.pinEnabled = Boolean(enabled);
          if (this.pinEnabled) return;
          const rect = this.stage.getBoundingClientRect();
          const top = rect.top + window.scrollY;
          const shortLandscape = window.innerWidth > height && height <= 600;
          this.start = Math.max(0, top - height * .7);
          this.end = Math.max(this.start + (shortLandscape ? 80 : 160), top + rect.height * (shortLandscape ? .3 : .65) - Math.max(112, height * .25));
        };
        this.updateProgress = () => {
          this.frame = null;
          if (!this.demoConnected || !this.imageReady || this.preference.matches || this.dataset.animate !== 'true') return;
          const rawProgress = Math.max(0, Math.min(1, (window.scrollY - this.start) / (this.end - this.start)));
          const progress = this.pinEnabled ? Math.max(0, Math.min(1, (rawProgress - .08) / .8)) : rawProgress;
          if (this.pinEnabled) this.runway.dataset.pinProgress = rawProgress.toFixed(4);
          if (this.didScroll && (rawProgress === 0 || rawProgress === 1)) this.manualProgress = null;
          this.didScroll = false;
          if (this.manualProgress !== null) {
            const distance = Math.abs(window.scrollY - this.manualScrollY);
            const blend = Math.max(0, Math.min(1, (distance - 8) / 80));
            this.renderProgress(this.manualProgress * (1 - blend) + progress * blend);
            if (blend === 1) this.manualProgress = null;
          } else this.renderProgress(progress);
        };
        this.schedule = () => {
          if (!this.demoConnected || !this.imageReady || this.preference.matches || this.dataset.animate !== 'true' || this.frame !== null) return;
          this.frame = window.requestAnimationFrame(this.updateProgress);
        };
        this.onResize = () => {
          if (!this.demoConnected || this.layoutFrame !== null) return;
          this.layoutFrame = window.requestAnimationFrame(() => {
            this.layoutFrame = null;
            if (!this.demoConnected) return;
            this.measure();
            this.schedule();
          });
        };
        this.onScroll = () => {
          if (Math.abs(window.scrollY - this.previousScrollY) > .5) this.didScroll = true;
          this.previousScrollY = window.scrollY;
          this.schedule();
        };
        this.onImageReady = () => {
          if (!this.demoConnected) return;
          this.imageReady = Boolean(this.demoImage?.complete && this.demoImage.naturalWidth > 0);
          if (!this.imageReady) this.stop();
          this.onResize();
        };
        this.onClick = event => {
          const button = event.target.closest('[data-demo-color]');
          if (!button) return;
          this.stop();
          this.manualProgress = Number(button.dataset.demoColor) / 2;
          this.manualScrollY = window.scrollY;
          this.previousScrollY = window.scrollY;
          this.didScroll = false;
          this.renderProgress(this.manualProgress);
        };
        this.onMotionChange = () => {
          this.stop();
          this.dataset.reduced = String(this.preference.matches);
          if (this.preference.matches) this.renderProgress(Number(this.dataset.color || 0) / 2);
          this.onResize();
        };
        this.addEventListener('click', this.onClick);
        this.demoImage?.addEventListener('load', this.onImageReady);
        this.demoImage?.addEventListener('error', this.onImageReady);
        this.preference.addEventListener('change', this.onMotionChange);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        window.addEventListener('pageshow', this.onResize);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          if (this.hero) this.resizeObserver.observe(this.hero);
          if (this.navigation) this.resizeObserver.observe(this.navigation);
        }
        document.fonts?.addEventListener?.('loadingdone', this.onResize);
        document.fonts?.ready?.then(() => { if (this.demoConnected) this.onResize(); }).catch(() => {});
        this.onImageReady();
        this.onMotionChange();
        this.dataset.ready = 'true';
      }
      disconnectedCallback() {
        this.demoConnected = false;
        this.imageReady = false;
        this.stop?.();
        if (this.layoutFrame !== null) window.cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = null;
        this.resizeObserver?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('pageshow', this.onResize);
        this.demoImage?.removeEventListener('load', this.onImageReady);
        this.demoImage?.removeEventListener('error', this.onImageReady);
        this.preference?.removeEventListener('change', this.onMotionChange);
        document.fonts?.removeEventListener?.('loadingdone', this.onResize);
        this.removeEventListener('click', this.onClick);
        delete this.dataset.cardsMode;
        this.cards?.forEach(card => card.removeAttribute('aria-hidden'));
        if (this.runway) {
          delete this.runway.dataset.pinReady;
          delete this.runway.dataset.pinProgress;
          this.runway.style.removeProperty('--intro-pin-top');
          this.runway.style.removeProperty('--intro-track-height');
        }
      }
    });
  }
  if (!customElements.get('aircube-review-summary')) {
    customElements.define('aircube-review-summary', class extends HTMLElement {
      connectedCallback() {
        this.updateRating = () => {
          const score = this.querySelector('[data-ac-rating]');
          if (!score) return;
          const badge = this.querySelector('.jdgm-prev-badge');
          const rating = Number(badge?.getAttribute('data-average-rating'));
          const count = Number(badge?.getAttribute('data-number-of-reviews'));
          const valid = count > 0 && rating > 0 && rating <= 5;
          score.hidden = !valid;
          const label = valid ? rating.toFixed(1) + ' / 5' : '';
          if (score.textContent !== label) score.textContent = label;
        };
        this.ratingObserver = new MutationObserver(this.updateRating);
        this.ratingObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating', 'data-number-of-reviews'] });
        this.updateRating();
      }
      disconnectedCallback() { this.ratingObserver?.disconnect(); }
    });
  }
  if (document.querySelector('.ac-intro') && !window.AirCubeExternalLinks) {
    window.AirCubeExternalLinks = true;
    const managedLinks = new WeakMap();
    const updateExternalLink = anchor => {
      let destination;
      try {
        destination = new URL(anchor.getAttribute('href'), document.baseURI);
      } catch {
        return;
      }
      const external = ['http:', 'https:'].includes(destination.protocol) && destination.origin !== location.origin;
      if (external) {
        if (!managedLinks.has(anchor)) {
          managedLinks.set(anchor, { target: anchor.getAttribute('target'), noopener: anchor.relList.contains('noopener') });
        }
        anchor.target = '_blank';
        anchor.relList.add('noopener');
      } else if (managedLinks.has(anchor)) {
        const original = managedLinks.get(anchor);
        if (original.target === null) anchor.removeAttribute('target');
        else anchor.setAttribute('target', original.target);
        if (!original.noopener) anchor.relList.remove('noopener');
        managedLinks.delete(anchor);
      }
    };
    const scanExternalLinks = root => {
      if (root instanceof Element && root.matches('a[href]')) updateExternalLink(root);
      root.querySelectorAll?.('a[href]').forEach(updateExternalLink);
    };
    scanExternalLinks(document);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') {
          if (record.target.matches('a')) updateExternalLink(record.target);
        } else {
          record.addedNodes.forEach(scanExternalLinks);
        }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aircube-purchase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aircube-purchase')) {
    customElements.define('aircube-purchase', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.select = this.querySelector('[data-variant]');
        if (!this.select) return;
        this.addEventListener('change', event => {
          if (event.target === this.select) this.update();
        });
        this.update();
        this.dataset.enhanced = '';
        try { this.enhanceChoices(); }
        catch {
          this.choiceReady = false;
          this.querySelector('[data-native-selector]').hidden = false;
          this.querySelector('[data-finish-group]').hidden = true;
          this.querySelectorAll('[data-model-choice]').forEach(button => { button.hidden = true; });
        }
      }
      enhanceChoices() {
        this.variants = Array.from(this.select.options);
        this.modelButtons = Array.from(this.querySelectorAll('[data-model-choice]'));
        const models = this.modelButtons.map(button => button.dataset.modelChoice);
        if (!this.variants.length || this.variants.some(option => !models.includes(option.dataset.model) || !option.dataset.finish)) return;
        const container = this.querySelector('[data-finishes]');
        this.finishButtons = [...new Set(this.variants.map(option => option.dataset.finish))].map(finish => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ac-purchase__finish';
          button.dataset.finish = finish;
          button.dataset.swatch = finish.toLowerCase();
          button.textContent = finish;
          const swatch = document.createElement('span');
          swatch.className = 'ac-purchase__swatch';
          swatch.setAttribute('aria-hidden', 'true');
          button.prepend(swatch);
          button.addEventListener('click', () => this.choose(this.select.selectedOptions[0].dataset.model, finish, false));
          container.append(button);
          return button;
        });
        this.modelButtons.forEach(button => button.addEventListener('click', () => {
          this.choose(button.dataset.modelChoice, this.select.selectedOptions[0].dataset.finish, true);
        }));
        this.choiceReady = true;
        this.update();
        this.modelButtons.forEach(button => { button.hidden = false; });
        this.querySelector('[data-finish-group]').hidden = false;
        this.querySelector('[data-native-selector]').hidden = true;
      }
      choose(model, finish, allowFinishFallback) {
        const matches = this.variants.filter(option => option.dataset.model === model && option.dataset.available === 'true');
        const option = matches.find(item => item.dataset.finish === finish) || (allowFinishFallback ? matches[0] : null);
        if (!option) return;
        this.select.value = option.value;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      update() {
        const option = this.select.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        this.querySelector('.ac-purchase__price').textContent = option.dataset.price;
        this.querySelector('[data-selected-title]').textContent = option.dataset.title || '';
        this.querySelector('[data-status]').textContent = available ? this.dataset.available : this.dataset.unavailable;
        const button = this.querySelector('[data-add-button]');
        button.disabled = !available;
        button.textContent = available ? this.dataset.add : this.dataset.unavailable;
        if (!this.choiceReady) return;
        this.modelButtons.forEach(control => {
          const selected = control.dataset.modelChoice === option.dataset.model;
          control.disabled = !this.variants.some(item => item.dataset.model === control.dataset.modelChoice && item.dataset.available === 'true');
          control.setAttribute('aria-pressed', String(selected));
          control.closest('.ac-purchase__model').classList.toggle('is-selected', selected);
          control.closest('.ac-purchase__model').classList.toggle('is-unavailable', control.disabled);
        });
        this.finishButtons.forEach(control => {
          const candidate = this.variants.find(item => item.dataset.model === option.dataset.model && item.dataset.finish === control.dataset.finish);
          control.disabled = !candidate || candidate.dataset.available !== 'true';
          control.setAttribute('aria-pressed', String(control.dataset.finish === option.dataset.finish));
          control.title = control.disabled ? control.dataset.finish + ' — ' + this.dataset.unavailable : control.dataset.finish;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aircube-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aircube-reviews')) {
    customElements.define('aircube-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { capture: true, signal: this.abort.signal };
        document.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          this.followReviewLink(event);
        }, options);
        document.addEventListener('keydown', event => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          if (!(event.target instanceof Element) || event.target.closest('a, button, input, select, textarea')) return;
          this.followReviewLink(event);
        }, options);
      }
      followReviewLink(event) {
        if (!(event.target instanceof Element)) return;
        const trigger = event.target.closest('[data-ac-reviews]');
        if (!trigger || this.contains(trigger)) return;
        const anchor = trigger.closest('a[href]');
        if (anchor) {
          const destination = new URL(anchor.href, location.href);
          if (anchor.target === '_blank' || anchor.hasAttribute('download') || destination.origin !== location.origin || destination.pathname !== location.pathname || !['#aircube-reviews', '#judgeme_product_reviews'].includes(destination.hash)) return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.scrollIntoView({ block: 'start', behavior: 'instant' });
        this.querySelector('[data-ac-reviews-focus]')?.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aircube-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aircube-color-demo')) {
    customElements.define('aircube-color-demo', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.visual = this.querySelector('svg');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.frame = 0;
        this.schedule = () => {
          if (!this.inView || !this.motionEnabled || this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.renderColor(); });
        };
        const options = { passive: true, signal: this.controller.signal };
        window.addEventListener('scroll', this.schedule, options);
        window.addEventListener('resize', this.schedule, options);
        window.visualViewport?.addEventListener('resize', this.schedule, options);
        this.onPreferenceChange = () => this.syncMotion();
        this.motionQuery.addEventListener('change', this.onPreferenceChange);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (!this.inView && this.frame) { cancelAnimationFrame(this.frame); this.frame = 0; }
          this.schedule();
        });
        this.observer.observe(this.visual);
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this.visual);
        this.syncMotion();
      }
      syncMotion() {
        const allowed = this.dataset.animate !== 'false';
        this.motionEnabled = allowed && !this.motionQuery.matches;
        this.dataset.motion = this.motionEnabled ? 'scroll' : 'static';
        if (this.motionEnabled) this.schedule();
        else {
          cancelAnimationFrame(this.frame);
          this.frame = 0;
          this.style.removeProperty('--ac-glow-color');
        }
      }
      renderColor() {
        const rect = this.visual.getBoundingClientRect();
        const viewport = window.visualViewport?.height || window.innerHeight;
        const center = rect.top + rect.height / 2 - (window.visualViewport?.offsetTop || 0);
        const progress = Math.max(0, Math.min(1, (viewport * 0.84 - center) / (viewport * 0.38)));
        const colors = [[88, 220, 139], [246, 216, 93], [255, 151, 78], [250, 88, 92]];
        const segment = Math.min(2, Math.floor(progress * 3));
        const fraction = progress * 3 - segment;
        const rgb = colors[segment].map((channel, i) => Math.round(channel + (colors[segment + 1][i] - channel) * fraction));
        this.style.setProperty('--ac-glow-color', 'rgb(' + rgb.join(',') + ')');
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.motionQuery?.removeEventListener('change', this.onPreferenceChange);
        cancelAnimationFrame(this.frame);
      }
    });
  }
  if (!customElements.get('aircube-screenshot')) {
    customElements.define('aircube-screenshot', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-screenshot-open]');
        if (!this.trigger || typeof this.dialog?.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.trigger.setAttribute('aria-haspopup', 'dialog');
        this.trigger.setAttribute('aria-controls', this.dialog.id);
        this.trigger.addEventListener('click', event => {
          if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          try {
            this.dialog.showModal();
          } catch {
            return;
          }
          event.preventDefault();
          this.returnFocus = this.trigger;
          this.lockScroll();
          const image = this.dialog.querySelector('img[data-src]');
          if (image && !image.getAttribute('src')) image.src = image.dataset.src;
        }, options);
        this.querySelector('[data-screenshot-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('pointerdown', event => {
          this.backdropPointer = event.target === this.dialog && this.outsideDialog(event);
        }, options);
        this.dialog.addEventListener('click', event => {
          if (this.backdropPointer && event.target === this.dialog && this.outsideDialog(event)) this.dialog.close();
          this.backdropPointer = false;
        }, options);
        this.dialog.addEventListener('close', () => {
          this.unlockScroll();
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
          this.returnFocus = null;
        }, options);
      }
      outsideDialog(event) {
        const bounds = this.dialog.getBoundingClientRect();
        return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
      }
      lockScroll() {
        if (this.scrollState) return;
        this.scrollState = [document.documentElement, document.body].filter(Boolean).flatMap(element => {
          return ['overflow-x', 'overflow-y'].map(property => ({ element, property, value: element.style.getPropertyValue(property), priority: element.style.getPropertyPriority(property) }));
        });
        this.scrollState.forEach(({ element, property }) => element.style.setProperty(property, 'hidden'));
      }
      unlockScroll() {
        this.scrollState?.forEach(({ element, property, value, priority }) => {
          if (value) element.style.setProperty(property, value, priority);
          else element.style.removeProperty(property);
        });
        this.scrollState = null;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        if (this.dialog?.open) this.dialog.close();
        this.unlockScroll();
        this.returnFocus = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
